"use client";
import { createContext } from 'react';

/**
 * Internal, exported only for usage in Framer
 */
const SwitchLayoutGroupContext = createContext({});

export { SwitchLayoutGroupContext };
//# sourceMappingURL=SwitchLayoutGroupContext.mjs.map
